import { createReducer, on } from '@ngrx/store';
import { CmsPageContentType } from '@rd/types';
import {
  CmsGetRefKeyFailed,
  CmsGetRefKeySuccess,
  CmsLoadPageContent,
  CmsLoadPageContentFailed,
  CmsLoadPageContentSuccess,
} from './cms.actions';

export interface CmsPageContentState {
  content: CmsPageContentType | null;
  loading: boolean;
  error: Error | null;
}

export interface CmsState {
  ref: string | null;
  error: Error | null;
  pages: Record<string, CmsPageContentState>;
}

const initialState: CmsState = {
  ref: null,
  error: null,
  pages: {},
};

export const cmsReducer = createReducer(
  initialState,
  on(CmsGetRefKeySuccess, (state, action) => ({
    ...state,
    ref: action.ref,
    error: null,
  })),
  on(CmsGetRefKeyFailed, (state, action) => ({
    ...state,
    ref: null,
    error: action.error,
  })),
  on(CmsLoadPageContent, (state, action) => ({
    ...state,
    pages: {
      ...state.pages,
      [action.pageName]: {
        content: null,
        loading: true,
        error: null,
      },
    },
  })),
  on(CmsLoadPageContentSuccess, (state, action) => ({
    ...state,
    pages: {
      ...state.pages,
      [action.pageName]: {
        content: action.data,
        loading: false,
        error: null,
      },
    },
  })),
  on(CmsLoadPageContentFailed, (state, action) => ({
    ...state,
    pages: {
      ...state.pages,
      [action.pageName]: {
        content: null,
        loading: false,
        error: action.error,
      },
    },
  })),
);
